import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { Student } from 'src/app/model/student/student.model';
import { SchoolEnrollment } from '../../../model/school-enrollment.model';
import { StudentSchoolEnrollmentService } from '../../../service/student-school-enrollment.service';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'delete-child-enrollment-check',
    templateUrl: './delete-child-enrollment-check.component.html',
    styleUrls: ['./delete-child-enrollment-check.component.scss']
})
export class DeleteChildEnrollmentCheckComponent implements OnInit {
    @Input() schoolEnrollments!: any[];
    @Input() students: Student[];

    @Output() setDoneLoading: EventEmitter<any> = new EventEmitter();

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    // Table display
    displayedColumns: string[] = ['WARNINGS', 'SCHOOL.NAME', 'SERVICE_DELIVERIES[0].NAME', 'ACTION', 'SCHOOLS[0].NAME'];

    // Table results
    tableDataSources: MatTableDataSource<any>[] = [];

    msg: MsgModel;

    isLoading: boolean = false;
    promises: Array<any> = [];

    getPropertyPipe: GetPropertyPipe = new GetPropertyPipe();
    titlecasePipe: TitleCasePipe = new TitleCasePipe();

    constructor(private studentSchoolEnrollmentService: StudentSchoolEnrollmentService) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.buildIntoSchoolEnrollments();

        this.getServicesForSchoolEnrollment();
        this.getOtherSchoolsInSameSchoolYear();
        this.getSchoolEnrollmentCoes();

        Promise.all(this.promises).then((res) => {
            this.checkDifferentGrades();
            this.setSchoolEnrollmentProperties();

            if (this.students && this.students.length > 0) {
                this.displayedColumns = ['WARNINGS', 'NAME', 'MSD_NUMBER', 'SCHOOL.NAME', 'SERVICE_DELIVERIES[0].NAME', 'ACTION', 'SCHOOLS[0].NAME'];
            } else {
                this.displayedColumns = ['WARNINGS', 'SCHOOL.NAME', 'SERVICE_DELIVERIES[0].NAME', 'ACTION', 'SCHOOLS[0].NAME'];
            }

            this.isLoading = false;

            this.updateDataSource();

            this.setDoneLoading.emit(true);
        });
    }

    buildIntoSchoolEnrollments() {
        if (this.schoolEnrollments) {
            if (this.students) {
                this.students.forEach((student) => {
                    let sed = JSON.parse(JSON.stringify(student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS[0] : undefined));
                    if (sed) {
                        if (!sed.SCHOOL && student.SCHOOL) {
                            sed['SCHOOL'] = student.SCHOOL;
                        }
                        sed['PERSON'] = student.PERSON;
                        sed['MSD_NUMBER'] = student.MSD_NUMBER;
                        this.schoolEnrollments.push(sed);
                    }
                });
            }

            this.schoolEnrollments = this.resolveDuplicates(this.schoolEnrollments);
        } else {
            this.schoolEnrollments = [];

            if (this.students) {
                this.students.forEach((student) => {
                    let sedBuilt = JSON.parse(JSON.stringify(student ? student : undefined));
                    let sed = JSON.parse(JSON.stringify(student.SCHOOL_ENROLLMENT_DETAILS ? student.SCHOOL_ENROLLMENT_DETAILS[0] : undefined));
                    if (sedBuilt && sed) {
                        delete sedBuilt['SCHOOL_ENROLLMENT_DETAILS'];
                        sedBuilt['SCHOOL_ENROLLMENT_DETAILS_ASL'] = sed;
                        sedBuilt['ID'] = sed.ID;
                        this.schoolEnrollments.push(sedBuilt);
                    }
                });
            }

            this.schoolEnrollments = this.resolveDuplicates(this.schoolEnrollments);
        }

        this.schoolEnrollments.forEach((se) => {
            se.SERVICE_DELIVERIES = [];
            se.SCHOOLS = [];
        });
    }
    getServicesForSchoolEnrollment() {
        let deferred = new Promise((resolve, reject) => {
            let sed: any = this.schoolEnrollments.map((sed) => {
                return { ID: sed.ID };
            });
            this.studentSchoolEnrollmentService.getServicesForSchoolEnrollment(sed).subscribe((res) => {
                if (res.schoolEnrollments) {
                    this.schoolEnrollments = this.mergeArrays(this.schoolEnrollments, res.schoolEnrollments, ['ID', 'SERVICE_DELIVERIES']);
                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }
    getOtherSchoolsInSameSchoolYear() {
        let deferred = new Promise((resolve, reject) => {
            let sed: any = this.schoolEnrollments.map((sed) => {
                return { ID: sed.ID };
            });
            this.studentSchoolEnrollmentService.getOtherSchoolsInSameSchoolYear(sed).subscribe((res) => {
                if (res.schoolEnrollments) {
                    this.schoolEnrollments = this.mergeArrays(this.schoolEnrollments, res.schoolEnrollments, ['ID', 'SCHOOLS']);
                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }
    getSchoolEnrollmentCoes() {
        let deferred = new Promise((resolve, reject) => {
            let sed: any = this.schoolEnrollments.map((sed) => {
                return { ID: sed.ID };
            });
            this.studentSchoolEnrollmentService.getSchoolEnrollmentCoes(sed).subscribe((res) => {
                if (res.schoolEnrollments) {
                    this.schoolEnrollments = this.mergeArrays(this.schoolEnrollments, res.schoolEnrollments, ['ID', 'COES']);
                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    checkDifferentGrades() {
        let deferred = new Promise((resolve, reject) => {
            this.schoolEnrollments.forEach((se: any) => {
                se.SCHOOLS = se.SCHOOLS.map((s: any) => {
                    return Object.assign(s, { differentGradeCount: 0 });
                });

                se.SERVICE_DELIVERIES.find((sd: any) => {
                    se.SCHOOLS.find((s: any) => {
                        if (s.GRADE !== sd.GRADE) {
                            s.differentGradeCount++;

                            return (se.differentGrade = true);
                        } else {
                            return false;
                        }
                    });

                    if (se.differentGrade) {
                        return (se.differentGrade = true);
                    } else {
                        return false;
                    }
                });

                se.SCHOOLS = se.SCHOOLS.sort((n1: any, n2: any) => (n1.differentGradeCount! > n2.differentGradeCount! ? -1 : 1));
            });

            resolve(undefined);
        });

        this.promises.push(deferred);
    }

    setSchoolEnrollmentProperties() {
        this.schoolEnrollments.forEach((se) => {
            se.WARNINGS = [];
            se.ACTION = {
                STRING: '---',
                CLASS: ''
            };
            se.NEW_ANCHOR = false;

            if (se.PERSON) {
                let name: string = '';
                name += se.PERSON.LAST_NAME;
                name += se.SECOND_LAST_NAME ? ' ' + se.SECOND_LAST_NAME : '';
                name += ', ' + se.PERSON.FIRST_NAME;
                name += se.PERSON.MIDDLE_INITIAL ? ' ' + se.PERSON.MIDDLE_INITIAL : '';

                name = this.titlecasePipe.transform(name);

                se.NAME = name;
            }

            /***************** WARNINGS + ACTIONS *****************/
            // Delete Services
            if (se.SERVICE_DELIVERIES.length > 0 && se.SCHOOLS.length === 0) {
                let warning = {
                    CLASS: 'danger',
                    TOOLTIP: 'Deleting this school enrollment will also delete the affected services. Eligibility may be affected.',
                    ICON: 'warning'
                };
                se.WARNINGS.push(warning);

                se.ACTION = {
                    STRING: 'Delete',
                    CLASS: 'danger'
                };
            }

            // Move Services to same school anchor
            if (se.SERVICE_DELIVERIES.length > 0 && se.SCHOOLS.length > 0 && se.SCHOOL.ID !== se.SCHOOLS[0].ID) {
                let warning = {
                    CLASS: 'warning',
                    TOOLTIP:
                        'Safe to delete school enrollment, the affected services will be anchored to a school within the same school year. Eligibility may be affected.',
                    ICON: 'warning'
                };
                se.WARNINGS.push(warning);

                se.ACTION = {
                    STRING: 'Move',
                    CLASS: 'warning'
                };
            }

            // Move Services to different school anchor
            if (se.SERVICE_DELIVERIES.length > 0 && se.SCHOOLS.length > 0 && se.SCHOOL.ID === se.SCHOOLS[0].ID && se.SCHOOLS[0].differentGradeCount > 0) {
                let warning = {
                    CLASS: 'warning',
                    TOOLTIP:
                        'Safe to delete school enrollment, the affected services will be anchored to a school within the same school year. Eligibility may be affected.',
                    ICON: 'warning'
                };
                se.WARNINGS.push(warning);

                se.ACTION = {
                    STRING: 'Grade Change',
                    CLASS: 'warning'
                };
            }

            // Safe to delete, no services
            if (
                (se.SERVICE_DELIVERIES.length === 0 && se.SCHOOLS.length >= 0) ||
                (se.SCHOOLS.length > 0 && se.SCHOOL.ID === se.SCHOOLS[0].ID && !se.SCHOOLS[0].differentGradeCount)
            ) {
                let warning = {
                    CLASS: 'success',
                    TOOLTIP: 'Safe to delete. Eligibilities may be affected',
                    ICON: 'check'
                };
                se.WARNINGS.push(warning);
            }

            // COE School Enrollment
            if (se.COES && se.COES.length > 0) {
                let warning = {
                    CLASS: '',
                    TOOLTIP: 'This School Enrollment was created by a COE.',
                    ICON: 'book'
                };
                se.WARNINGS.push(warning);
            }

            // INA detected
            if (se.INA_ID > 0) {
                let warning = {
                    CLASS: 'warning',
                    TOOLTIP: 'This School Enrollment is linked to an INA/ILP.',
                    ICON: 'error'
                };
                se.WARNINGS.push(warning);
            }

            /***************** ANCHORS *****************/
            // Has Anchor
            if (se.SERVICE_DELIVERIES.length > 0 && se.SCHOOLS.length > 0) {
                se.NEW_ANCHOR = true;
            }
        });
    }

    updateDataSource() {
        this.tableDataSources = [];

        setTimeout(() => {
            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.schoolEnrollments;

            // Paginator
            //dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'PERSON.LAST_NAME', direction: 'asc' };
            dataSource.sort.active = defaultSort.active;
            dataSource.sort.direction = defaultSort.direction;
            dataSource.sort.sortChange.emit(defaultSort);
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSources.push(dataSource);
        });
    }

    resolveDuplicates(schoolEnrollments: SchoolEnrollment[]): SchoolEnrollment[] {
        var uniques = [...new Map(schoolEnrollments.map((se) => [se['ID'], se])).values()];

        return uniques;
    }

    mergeArrays(targetArray: any[], mergingArray: any[], propertiesToMerge: string[]) {
        if (propertiesToMerge) {
            mergingArray.forEach((obj) => {
                for (let propertyName in obj) {
                    if (
                        !propertiesToMerge.find((property) => {
                            return property === propertyName;
                        })
                    ) {
                        delete obj[propertyName];
                    }
                }
            });
        }

        let result: any[] = targetArray.map((obj) => {
            return Object.assign(
                obj,
                mergingArray.find((ma) => ma.ID === obj.ID)
            );
        });

        return result;
    }
}
